"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-tree-select", _vm._b({
    style: {
      width: _vm.width
    },
    attrs: {
      "show-arrow": true,
      "dropdown-style": {
        maxHeight: "400px",
        overflow: "auto"
      },
      "dropdown-match-select-width": true,
      "filter-tree-node": _vm.handleFilterTreeNode,
      multiple: _vm.treeCheckable ? true : _vm.multiple,
      "tree-data": _vm.transformedData,
      "search-value": _vm.searchValue
    },
    on: {
      "update:searchValue": function ($event) {
        _vm.searchValue = $event;
      },
      "update:search-value": function ($event) {
        _vm.searchValue = $event;
      },
      change: _vm.handleChange,
      search: _vm.handleSearch,
      treeExpand: _vm.handleTreeExpand,
      blur: _vm.handleBlur
    },
    model: {
      value: _vm.selectedNode,
      callback: function ($$v) {
        _vm.selectedNode = $$v;
      },
      expression: "selectedNode"
    }
  }, "a-tree-select", _vm.$props, false));
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;